import { useEffect, useRef } from "react";
import gsap from "gsap";

export function useScrollSnap() {
  const programmaticScroll = useRef(false);

  useEffect(() => {
    let scrollTimeout;
    let isAnimating = false;

    const getScrollTop = () =>
      typeof window === "undefined"
        ? 0
        : (window.scrollY ??
          window.pageYOffset ??
          document.scrollingElement?.scrollTop ??
          document.documentElement.scrollTop ??
          0);

    const snapToClosest = () => {
      if (isAnimating) return;

      const panels = document.querySelectorAll(".panel");
      if (!panels.length) return;

      // Past the last panel (the home footer): leave the scroll alone, or the
      // footer would be snapped back out of view
      const lastPanel = panels[panels.length - 1];
      if (lastPanel.getBoundingClientRect().bottom <= window.innerHeight) {
        return;
      }

      const scrollTop = getScrollTop();
      let closestPanel;

      // Special case: if near the very top, snap to the first panel
      if (scrollTop < window.innerHeight * 0.25) {
        closestPanel = panels[0];
      } else {
        let closestDistance = Infinity;
        panels.forEach((panel) => {
          const distance = Math.abs(panel.getBoundingClientRect().top);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestPanel = panel;
          }
        });
      }

      if (closestPanel) {
        isAnimating = true;
        programmaticScroll.current = true; // lock while animating

        gsap.to(window, {
          scrollTo: { y: closestPanel, offsetY: 0 },
          duration: 0.2,
          ease: "power3.inOut",
          onComplete: () => {
            isAnimating = false;
            programmaticScroll.current = false; // release lock
          },
        });
      }
    };

    const onScroll = () => {
      if (isAnimating || programmaticScroll.current) return;

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        if (!isAnimating && !programmaticScroll.current) {
          snapToClosest();
        }
      }, 1000);
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  return programmaticScroll;
}
